import './index_mWeb.css';
import FlatList from 'flatlist-react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  FlatListWrapper,
  HeaderWithTimer,
  PaginationIndicator,
  RouteWrapper
} from '../../../component';
import EventEmitter from '../../../utilities/EventEmitter';
import useGame from '../../../utilities/hooks/game';
import { useLink } from 'react-router-stack';
import constants from '../../../constants';
import ContestResultCardMWeb from '../../component/contest_result_card/index_mWeb';
import ScreenBackgroundWrapper from '../../../component/screen_background_wrapper';

const MyContestListMWeb = ({ onPressCard }: any) => {
  const navigate = useLink();
  const { gameType, item: matchItem, myTeamList = [] } = useGame();
  const { myContestList: fantasyCricketMyContestList } = useSelector(
    (state: any) => state.fantasy_cricket
  );
  const { myContestList: fantasyFootballMyContestList } = useSelector(
    (state: any) => state.fantasy_football
  );

  const [error, setError] = useState(false);

  const { tabType = 'FIXTURE', verified = false } = matchItem;
  const [challenges, setChallenges] = useState([] as any);

  useEffect(() => {
    getMyJoinedContestAPI();
    getMyMatchTeamListAPI();
    EventEmitter.on('updateMyContests', getMyJoinedContestAPI_);
    return () => {
      EventEmitter.off('updateMyContests', getMyJoinedContestAPI_);
    };
  }, []);

  const getMyJoinedContestAPI_ = () => getMyJoinedContestAPI();

  const getMyMatchTeamListAPI = async () => {};

  const getMyJoinedContestAPI = async (skip = 0) => {
    let result: any = [];
    if (gameType === constants.GameType.FANTASY_CRICKET) {
      result = [...fantasyCricketMyContestList[matchItem._id]];
    }
    if (gameType === constants.GameType.FANTASY_FOOTBALL) {
      result = [...fantasyFootballMyContestList[matchItem._id]];
    }

    if (!error && result) {
      if (skip === 0) {
        setChallenges(result);
      } else {
        setChallenges((challenges: any): any[] => [...challenges, ...result]);
      }
      setError(false);
    } else {
      setError(true);
    }
  };

  const renderResultItem = (item: any) => (
    <ContestResultCardMWeb
      contest={item}
      onPressCard={() => onPressCard(item, true)}
      myTeamList={myTeamList}
      matchVerifiedStatus={verified}
    />
  );

  const onPressBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  return (
    <RouteWrapper>
      <ScreenBackgroundWrapper>
        <HeaderWithTimer
          onPressBack={onPressBack}
          matchItem={matchItem}
          tabType={tabType}
          onCalledDeadline={() => {}}
        />

        <FlatListWrapper className="my-contest-list-flat-list-wrapper_mWeb">
          <FlatList
            list={challenges}
            renderItem={renderResultItem}
            paginationLoadingIndicator={<PaginationIndicator />}
          />
        </FlatListWrapper>
      </ScreenBackgroundWrapper>
    </RouteWrapper>
  );
};

export default MyContestListMWeb;
